import PropTypes from 'prop-types';

/*
utils to handle common logic related to adding borders to components via PropTypes
*/
function generateBorderPropTypes({
  denylist = []
} = {}) {
  const shape = {
    top: PropTypes.bool,
    right: PropTypes.bool,
    bottom: PropTypes.bool,
    left: PropTypes.bool
  };
  denylist.forEach(k => {
    delete shape[k];
  });
  return PropTypes.shape(shape);
}
const borderPropTypes = generateBorderPropTypes();

/**
 * Given the spacing props, returns an array of CSS classes to apply the padding/margin
 * @param {object} settings The margin or padding props
 * @returns {array} array of CSS classes
 */
function getBorder(settings) {
  const finalSettings = {
    ...settings
  };
  if (!finalSettings) return null;
  const settingsArray = Object.keys(finalSettings);
  if (settingsArray.length === 0) return null;
  const sidemap = {
    top: 't',
    left: 'l',
    right: 'r',
    bottom: 'b'
  };
  return settingsArray.map(side => `st_border--${sidemap[side]}`);
}

/**
 * Given an object with props from user, returns a new object that removes
 * all properties that are disallowed
 *
 * @param {object} settings the border props provided to component
 * @param {array} denylist array of strings with name of disallowed props
 */
function sanitizeProps(settings, denylist = []) {
  const newSettings = {
    ...settings
  };
  Object.keys(settings).forEach(k => {
    if (denylist.includes(k)) delete newSettings[k];
  });
  return newSettings;
}

/*
given array of original css class arrays
and margin PropTypes
return new array with margin classes, or the original aray
*/
function addBorderClasses(border, cssClasses = [], denylist = []) {
  if (!border || Object.keys(border).length === 0) return cssClasses;
  return (cssClasses || []).concat(getBorder(sanitizeProps(border, denylist) || []));
}

export { addBorderClasses as a, borderPropTypes as b };
